import React from "react";

export const VerifiedUsersPostsPage = () => <p>VerifiedUsersPostsPage</p>;
